export const lightPallete = {
	white: '#FFFFFF',
	grey: '#f8f8f8',
	blue: '#315AFE',
	red: '#DA5853',
	black: '#23212C',
	green: '#01BE83',
	orange: '#FF7833',
	greyFont: '#bfc5ce',
	greyDark: '#9E9EA2',
	greyLight: '#F2F3FB',
	yellow: '#FFC726',
};

export const darkPallete = {
	white: '#212528',
	grey: '#272B2E',
	blue: '#577BF9',
	red: '#E05C53',
	black: '#EDE8ED',
	green: '#41B581',
	orange: '#FE6809',
	greyFont: '#54585B',
	greyDark: '#47484C',
	greyLight: '#54585E',
	yellow: '#D4B036',
};
